import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import "./scss/BusinessDetail.css"
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { Button, TextField, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import axios from 'axios';
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

function BusinessDetail() {
  const navigate = useNavigate();
  const location = useLocation();
  const stateData = location.state;

  const [data, setData] = useState("");

  useEffect(() => {
    if (stateData != null) {
      setData(stateData.data)
    }

  }, [stateData])
  console.log(data)


  const handleApprove = async () => {

  
    if (data.roles.name === "Vendor") {
      const res = await axios.post(`${process.env.REACT_APP_STEELADMIN}/superAdmin/vendorApproveRequest/${data.id}`).then((res) => {
        console.log(res.data);
        navigate("/allrequest")
      })
    }

    else {

      const res = await axios.post(`${process.env.REACT_APP_STEELADMIN}/superAdmin/corporateApproveRequest/${data.id}`).then((res) => {
        console.log(res.data);
        navigate("/allrequest")
      })
    }



  }


  const handleDeny = async () => {
    if (data.roles.name === "Vendor") {
      const res = await axios.post(`${process.env.REACT_APP_STEELADMIN}/superAdmin/declineRequestOfVendor/${data.id}`).then((res) => {
        console.log(res.data);
        navigate("/allrequest")
      })
    }
    else {

      const res = await axios.post(`${process.env.REACT_APP_STEELADMIN}/superAdmin/declineRequestOfCorporate/${data.id}`).then((res) => {
        console.log(res.data);
        navigate("/allrequest")
      })
    }
  }
  console.log(data)


  return (
    <div className='MyprofileBusMain'>
  
      <Box className='businessname' sx={{ flexGrow: 1, bgcolor: '#fff', p: '3%' }}>
        <div className='MyprofileMain'>
          <Typography variant='h3'>{data?.name}</Typography>
          <div className='ApprovalButtton'>
            <Button variant="contained" onClick={handleApprove}>Approve</Button>
            <Button variant="outlined" onClick={handleDeny}>Deny</Button>
          </div>
        </div>
        <Box className='BusinessProfile'>
        <div className='BusinessInputFields'>
        <Typography variant='h6'>Business Detail</Typography>
        <Grid className='BusinesNAmeStart' container spacing={4}>
          <Grid item xs={6}>
            <label>Business name</label>
            <input value={data.name}>
            </input>
          </Grid>
          <Grid item xs={6}>
            <label>Email</label>
            <input value={data.email}>
            </input>
          </Grid>
        </Grid>
        <Grid className='BusinesNAmeStart' container spacing={4}>
        <Grid item xs={6}>
            <label>Phone Number</label>
            <input value={data.phoneNumber}>
            </input>
          </Grid>
          <Grid item xs={6}>
            <label>Website</label>
            <input value={data.website}>
            </input>
          </Grid>
        </Grid>
        <Grid className='BusinesNAmeStart' container spacing={4}>
        <Grid item xs={6}>
            <label>Register On</label>
            <input value={data.dateCreated}>
            </input>
          </Grid>
          <Grid item xs={6}>
            <label>Role</label>
            <input value={data.roles?.name}>
            </input>
          </Grid>
        </Grid>
        </div>

        <div className='BusinessProfileImage'>
             <img src="https://res.cloudinary.com/dtffniutw/image/upload/v1690375856/Ellipse_rzklc6.png" alt="" />
        </div>
        </Box>
      </Box>

     {
      data?.roles?.name === "Vendor" &&
      <Box className='businessname' sx={{ flexGrow: 1, mt: '5%', bgcolor: '#fff', p: '3%' }}>
      <div className='BusinessInputFields'>
       <Typography variant='h6'>Tax Detail</Typography>
        <Grid className='BusinesNAmeStart' container spacing={3}>
          <Grid item xs={6}>
            <label>Contry</label>
            <input value={data.country}>
            </input>
          </Grid>
          <Grid item xs={6}>
            <label>Address</label>
            <input value={data.businessAddress}>
            </input>
          </Grid>
        </Grid>
        <Grid className='BusinesNAmeStart' container spacing={3}>
        <Grid item xs={6}>
            <label>Pan number</label>
            <input value={data.panNo}>
            </input>
          </Grid>
          <Grid item xs={6}>
            <label>GST number</label>
            <input value={data.gstNo}>
            </input>
          </Grid>
          <Grid item xs={6} sx={{mt:'-20px'}}>
            <label>VAT number</label>
            <input value={data.gstNo}>
            </input>
          </Grid>
    
        </Grid>
        </div>


      </Box>
     }
      


      {/* <Box className='businessname' sx={{ flexGrow: 1, mt: '5%', bgcolor: '#fff', p: '3%' }}>
        <Typography variant='h6'>Bank details</Typography>
        <Grid className='BusinesNAmeStart' container spacing={3}>
          <Grid item xs={3}>
            <label>Account name</label>
            <input>
            </input>
          </Grid>
          <Grid item xs={3}>
            <label>Account Number</label>
            <input>
            </input>
          </Grid>
          <Grid item xs={3}>
            <label>IFSC Code</label>
            <input>
            </input>
          </Grid>
        </Grid>
        <Grid className='BusinesNAmeStart' container spacing={3}>
          <Grid item xs={3}>
            <label>Bank name</label>
            <input>
            </input>
          </Grid>


          <Grid className='BusinesNAmeStart' item xs={3}>
            <label>Branch</label>
            <input>
            </input>
          </Grid>

        </Grid>
      </Box> */}
    </div>
  );
}
export default BusinessDetail